import { render, staticRenderFns } from "./Radiator.vue?vue&type=template&id=4686a3c3"
import script from "./Radiator.vue?vue&type=script&lang=js"
export * from "./Radiator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports